var url = window.location.href.split('/');

var platform = 'dev';

export var SITE_URL = url[2];

export var DEBUG = true;
export var EVENT_LOGGING = true;

export var API_URL = function API_URL() {
  switch (SITE_URL) {
    case 'localhost:17005':
    case 'localhost:17006':
    case '127.0.0.1:17006':
      //return 'https://b98b911b.ngrok.io';
      return 'https://localhost:8000';

    case '10.0.2.2:17006':
      return 'https://10.0.2.2:8000';

    case 'explore.staging.localvore.co':
    case 'merchants.staging.localvore.co':
    case 'prerender.staging.localvore.co':
      platform = 'staging';
      return 'https://api.staging.localvore.co';

    case 'localvore.co':
    case 'www.localvore.co':
    case 'explore.localvore.co':
    case 'merchants.localvore.co':
      //return 'https://api.localvore.co';
      platform = 'production';
      return 'https://08232017.prod.localvore.co';

    default:
      return 'https://localhost:8000';
  }
};

export var API_VERSION = '2016-10-28';

export var MERCHANT_REQUEST_DEFAULTS = {
  data: {
    id: 'localvore.subscriber.web',
    attributes: {
      scope: 'merchant'
    }
  }
};

export var EXPLORE_REQUEST_DEFAULTS = {
  data: {
    id: 'localvore.explore.web',
    attributes: {
      scope: 'default'
    }
  }
};

export var CONFIG_DEVELOPMENT = {
  "MAPBOX_KEY": "pk.eyJ1IjoiYmFrZWRiZWFuIiwiYSI6ImNpeG01cDR1MTAwZ3ozM21vdDU4dTU4d20ifQ.nGmGJv-JgJQh1LwAx_z-8w",
  "MAPBOX_STYLE": "mapbox://styles/bakedbean/ciy5v5uh3002x2snq96ztnzrs",
  "ALGOLIA_ID": "JD1AAZBXH9",
  "ALGOLIA_KEY": "7ea54b3483b2b3358d237683dbe6caa3",
  "ALGOLIA_INDEX": "places_eben",
  "STRIPE_KEY": "pk_test_b8Uz7gKiD53tWmXwia3Kam7c",
  "CLOUDINARY_NAME": "localvore-today",
  "CLOUDINARY_KEY": "738815799822538",
  "CLOUDINARY_PRESET": "ic3h4h7l",
  "INSTAGRAM_CLIENT_ID": "7ed8e290c2ec4db9833084a7e1be1db0"
};

export var CONFIG_STAGING = {
  "MAPBOX_KEY": "pk.eyJ1IjoiZG12dC1sb2NhbHZvcmUiLCJhIjoiY2l6OG13ZGhlMDB4ZjMybXFobmU4cHdzdyJ9.jyOtW-atTDKez8nOEUYzEA",
  "MAPBOX_STYLE": "mapbox://styles/dmvt-localvore/ciz8q7adw003b2rnqdl2w5tnw",
  "ALGOLIA_ID": "JD1AAZBXH9",
  "ALGOLIA_KEY": "7ea54b3483b2b3358d237683dbe6caa3",
  "ALGOLIA_INDEX": "places_staging",
  "STRIPE_KEY": "pk_test_b8Uz7gKiD53tWmXwia3Kam7c",
  "CLOUDINARY_NAME": "localvore-today",
  "CLOUDINARY_KEY": "738815799822538",
  "CLOUDINARY_PRESET": "ic3h4h7l",
  "INSTAGRAM_CLIENT_ID": "7ed8e290c2ec4db9833084a7e1be1db0"
};

export var CONFIG_PRODUCTION = {
  "MAPBOX_KEY": "pk.eyJ1IjoiZG12dC1sb2NhbHZvcmUiLCJhIjoiY2l6OG13ZGhlMDB4ZjMybXFobmU4cHdzdyJ9.jyOtW-atTDKez8nOEUYzEA",
  "MAPBOX_STYLE": "mapbox://styles/dmvt-localvore/ciz8q7adw003b2rnqdl2w5tnw",
  "ALGOLIA_ID": "JD1AAZBXH9",
  "ALGOLIA_KEY": "7ea54b3483b2b3358d237683dbe6caa3",
  "ALGOLIA_INDEX": "places_prod",
  "STRIPE_KEY": "pk_live_216SbxaYd8tbvL8CXgQD3kvt",
  "CLOUDINARY_NAME": "localvore-today",
  "CLOUDINARY_KEY": "738815799822538",
  "CLOUDINARY_PRESET": "ic3h4h7l",
  "INSTAGRAM_CLIENT_ID": "7ed8e290c2ec4db9833084a7e1be1db0"
};

API_URL();
export var CONFIG = platform !== 'dev' ? platform !== 'staging' ? CONFIG_PRODUCTION : CONFIG_STAGING : CONFIG_DEVELOPMENT;

export var CUISINE_LIST = [{
  value: '',
  label: 'Choose'
}, {
  value: 'arab',
  label: 'Arab'
}, {
  value: 'armenian',
  label: 'Armenian'
}, {
  value: 'american',
  label: 'American'
}, {
  value: 'american-new',
  label: 'American (New)'
}, {
  value: 'american-southern',
  label: 'American (Southern)'
}, {
  value: 'american-southwestern',
  label: 'American (Southwestern)'
}, {
  value: 'argentinian',
  label: 'Argentinian'
}, {
  value: 'asian',
  label: 'Asian'
}, {
  value: 'bulgarian',
  label: 'Bulgarian'
}, {
  value: 'barbecue',
  label: 'Barbecue'
}, {
  value: 'cajun',
  label: 'Cajun'
}, {
  value: 'caribbean',
  label: 'Caribbean'
}, {
  value: 'chinese',
  label: 'Chinese'
}, {
  value: 'cuban',
  label: 'Cuban'
}, {
  value: 'ethiopian',
  label: 'Ethiopian'
}, {
  value: 'west-african',
  label: 'West African'
}, {
  value: 'east-african',
  label: 'East African'
}, {
  value: 'english',
  label: 'English'
}, {
  value: 'south-african',
  label: 'South African'
}, {
  value: 'french',
  label: 'French'
}, {
  value: 'filipino',
  label: 'Filipino'
}, {
  value: 'gastro-pub',
  label: 'Gastro Pub'
}, {
  value: 'german',
  label: 'German'
}, {
  value: 'greek',
  label: 'Greek'
}, {
  value: 'hawaiian',
  label: 'Hawaiian'
}, {
  value: 'korean',
  label: 'Korean'
}, {
  value: 'irish',
  label: 'Irish'
}, {
  value: 'indian',
  label: 'Indian'
}, {
  value: 'indonesian',
  label: 'Indonesian'
}, {
  value: 'italian',
  label: 'Italian'
}, {
  value: 'japanese',
  label: 'Japanese'
}, {
  value: 'jewish',
  label: 'Jewish'
}, {
  value: 'louisiana-creole',
  label: 'Louisiana Creole'
}, {
  value: 'mexican',
  label: 'Mexican'
}, {
  value: 'mediterranean',
  label: 'Mediterranean'
}, {
  value: 'moroccan',
  label: 'Moroccan'
}, {
  value: 'nepalese',
  label: 'Nepalese'
}, {
  value: 'polish',
  label: 'Polish'
}, {
  value: 'pakistani',
  label: 'Pakistani'
}, {
  value: 'peruvian',
  label: 'Peruvian'
}, {
  value: 'portuguese',
  label: 'Portuguese'
}, {
  value: 'ecuadorian',
  label: 'Ecuadorian'
}, {
  value: 'seafood',
  label: 'Seafood'
}, {
  value: 'serbian',
  label: 'Serbian'
}, {
  value: 'spanish',
  label: 'Spanish'
}, {
  value: 'tapas',
  label: 'Tapas'
}, {
  value: 'thai',
  label: 'Thai'
}, {
  value: 'turkish',
  label: 'Turkish'
}, {
  value: 'vegetarian',
  label: 'Vegetarian'
}];


//////////////////
// WEBPACK FOOTER
// ../ui-utilities/es/constants.js
// module id = 101
// module chunks = 4